import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import K from '../../../../../constants';
import MoveInAppWarning from '../../../../../common/components/MoveInAppWarning';
import { CheckIcon } from '../../../../../common/icons/redesignIcons';

import './RegDone.css';

@inject('translationsStore')
@observer
class RegDone extends Component {
  onGoToMyPage = () => {
    window.location = `${K.AIR_MYPAGE_URL}`;
  };

  onOpenMail = () => {
    window.open('mailto:', '_blank');
    return null;
  };

  render() {
    const { translationsStore } = this.props;

    return (
      <div className="RegDone mv-hero-bg">
        <div className="RegDoneIcon">
          <span className="RegDoneIconRing1" />
          <span className="RegDoneIconRing2" />
          <span className="RegDoneIconCore">
            <CheckIcon size={26} strokeWidth="3.2" />
          </span>
        </div>
        <h1 className="mv-h1">{translationsStore.translate('movein.stepDone.title')}</h1>
        <p className="RegDoneText">{translationsStore.translate('registration.form.SuccessModal.weSentEmailWithCredential')} {translationsStore.translate('movein.stepDone.nextSteps')}</p>
        <div className="mv-card RegDoneCard">
          <div className="RegDoneStep">
            <span className="RegDoneStepNumber">1</span>
            <div>
              <div className="RegDoneStepTitle">{translationsStore.translate('movein.stepDone.step1Title')}</div>
              <div className="RegDoneStepText">{translationsStore.translate('registration.form.SuccessModal.ifNotPresentCheckYourSpam')}</div>
            </div>
          </div>
          <div className="RegDoneStep">
            <span className="RegDoneStepNumber">2</span>
            <div>
              <div className="RegDoneStepTitle">{translationsStore.translate('movein.stepDone.step2Title')}</div>
              <div className="RegDoneStepText">{translationsStore.translate('registration.form.SuccessModal.passwordReminder')}</div>
            </div>
          </div>
          <MoveInAppWarning />
          <div className="RegDoneActions">
            <button className="mv-btn RegDoneMyPage" onClick={this.onGoToMyPage}>
              {translationsStore.translate('movein.stepDone.goToMyPage')}
            </button>
            <button className="mv-btn mv-btn--ghost" onClick={this.onOpenMail}>
              {translationsStore.translate('movein.stepDone.openMail')}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default RegDone;
